import { usePersonalizedFeatures } from '../hooks/usePersonalizedFeatures';

/** Mounted once so the features query is in flight before the cards render. */
export const PersonalizedFeaturesPrefetch = () => {
  usePersonalizedFeatures();
  return null;
};
//# sourceMappingURL=PersonalizedFeaturesPrefetch.js.map